<template>
  <div>
    <tabs class="versions-tabs" ref="tab-sections" :value="(GrantForm.isOnARevisionTab ? $t('medium_grant.revision_tab__revised_version') : $t('medium_grant.revision_tab__original_version'))" @activate-tab="activateTab" type="info" square>
        <tab-pane id="original" :label="$t('medium_grant.revision_tab__original_version')">
        <grant-sub-wizard nickname="technical">
          <grant-sub-wizard-tab :before-change="() => validateStep('step1')">
            <page1 ref="step1"></page1>
          </grant-sub-wizard-tab>
        </grant-sub-wizard>
        </tab-pane>
        <tab-pane id="revised" :label="$t('medium_grant.revision_tab__revised_version')" v-if="GrantForm.hasRevision">
        <grant-sub-wizard nickname="technical">
          <grant-sub-wizard-tab :before-change="() => validateStep('revised-step1')">
            <revised-page1 ref="revised-step1"></revised-page1>
          </grant-sub-wizard-tab>
        </grant-sub-wizard>
      </tab-pane>
    </tabs>
  </div>
</template>

<script>
  import Page1 from './Page1';
  import RevisedPage1 from './Revised/Page1';

  import {TabPane, Tabs} from 'src/components';
  import {GrantSubWizard, GrantSubWizardTab} from '@/components';
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    components: {
      Tabs,
      TabPane,
      GrantForm,
      GrantSubWizard,
      GrantSubWizardTab,
      Page1,
      RevisedPage1,
    },
    methods: {
      activateTab(ev) {
        GrantForm.isOnARevisionTab = (ev.id === 'revised');
      },
      validateStep(ref) {
        return (this.$refs[ref].validate) ? this.$refs[ref].validate() : true;
      }
    }
  }
</script>

<style>
  textarea
  {
    min-height: 50px;
  }
</style>
